import { STEP, ACTION } from '../../@types/state'

const commercialStates = {
  id: 'commercialStates',
  initial: STEP.LOCATION,
  context: {
    skippedSteps: [],
  },
  states: {
    [STEP.LOCATION]: {
      entry: ['enterOrSkipLocation'],
      on: {
        [ACTION.BACK]: STEP.IBW_INITIAL,
        [ACTION.NEXT]: STEP.COMMERCIAL_REAL_ESTATE_TYPE,
        [ACTION.GO_TO_ERROR]: STEP.ERROR,
      },
    },
    [STEP.COMMERCIAL_REAL_ESTATE_TYPE]: {
      entry: ['enterOrSkipCommercialRealEstateType'],
      on: {
        [ACTION.BACK]: STEP.LOCATION,
        [ACTION.NEXT]: STEP.AREA,
      },
    },
    [STEP.AREA]: {
      entry: ['enterOrSkipArea'],
      on: {
        [ACTION.BACK]: STEP.COMMERCIAL_REAL_ESTATE_TYPE,
        [ACTION.NEXT]: STEP.INTENT,
      },
    },
    [STEP.INTENT]: {
      entry: ['enterOrSkipIntent'],
      on: {
        [ACTION.BACK]: STEP.AREA,
        [ACTION.NEXT]: [{ target: STEP.EQUITY, cond: 'isExtendedBuyerLead' }, { target: STEP.TIME_HORIZON }],
      },
    },
    [STEP.EQUITY]: {
      entry: ['enterOrSkipEquity'],
      on: {
        [ACTION.BACK]: STEP.INTENT,
        [ACTION.NEXT]: [{ target: STEP.INCOME, cond: 'isExtendedBuyerLead' }],
      },
    },
    [STEP.INCOME]: {
      entry: ['enterOrSkipIncome'],
      on: {
        [ACTION.BACK]: STEP.EQUITY,
        [ACTION.NEXT]: [{ target: STEP.EMPLOYMENT, cond: 'isExtendedBuyerLead' }],
      },
    },
    [STEP.EMPLOYMENT]: {
      entry: ['enterOrSkipEmployment'],
      on: {
        [ACTION.BACK]: STEP.INCOME,
        [ACTION.NEXT]: [{ target: STEP.TIME_HORIZON }],
      },
    },
    [STEP.TIME_HORIZON]: {
      entry: ['enterOrSkipTimeHorizon'],
      on: {
        [ACTION.BACK]: STEP.INTENT,
        [ACTION.NEXT]: STEP.OWNER,
      },
    },
    [STEP.OWNER]: {
      entry: ['enterOrSkipOwner'],
      on: {
        [ACTION.BACK]: STEP.TIME_HORIZON,
        [ACTION.NEXT]: STEP.PLEASE_WAIT,
      },
    },
    [STEP.PLEASE_WAIT]: {
      on: {
        [ACTION.NEXT]: STEP.CONTACT,
      },
    },
    [STEP.CONTACT]: {
      on: {
        [ACTION.NEXT]: [
          { target: STEP.RESPONSE_NON_HAPPY_PATH, cond: 'isNonHappyPath' },
          { target: STEP.RESPONSE_EXTENDED_BUYER_LEADS, cond: 'isExtendedBuyerLead' },
          { target: STEP.RESPONSE },
        ],
        [ACTION.GO_TO_ERROR]: STEP.ERROR,
      },
    },
    [STEP.RESPONSE_NON_HAPPY_PATH]: {
      on: {
        [ACTION.NEXT]: [{ target: STEP.RESPONSE }],
      },
    },
    [STEP.RESPONSE_EXTENDED_BUYER_LEADS]: {},
    [STEP.RESPONSE]: {},
    [STEP.ERROR]: {},
  },
}

export default commercialStates
